import React from 'react'
import Link from 'next/link'
import Layout from '@/components/Layout'
import RecoverPasswordView from '../../src/features/auth/views/RecoverPasswordView'
import { GetStaticProps, InferGetStaticPropsType } from 'next'
import { getStorefrontSettings } from '@/utils/cms'
import { StorefrontSettingsContext } from '@/stores'

const RecoverPasswordPage: React.FC<
  InferGetStaticPropsType<typeof getStaticProps>
> = ({ storefrontSettings }) => {
  return (
    <StorefrontSettingsContext.Provider value={storefrontSettings}>
      <Layout mutedBackground showLiveChatWidget>
        <div className={'page-wrapper container mx-auto'}>
          <div>
            <h2
              className={
                'text-2xl md:text-3xl mb-4 md:mb-10 font-bold text-center text-gray-800'
              }
            >
              Reset Password
            </h2>
            <div className={'max-w-sm mx-auto'}>
              <RecoverPasswordView />
            </div>
          </div>
        </div>
      </Layout>
    </StorefrontSettingsContext.Provider>
  )
}

export const getStaticProps: GetStaticProps = async (context) => {
  const storefrontSettings = await getStorefrontSettings()
  return {
    props: {
      storefrontSettings,
    },
  }
}

export default RecoverPasswordPage
